// PMax Campaign & Asset Group Structure — judgment row, Account Structure section.
// LLM-drafted verdict (rendered above by FindingCard); this is the supporting "structure Claude
// saw" view — each campaign with its asset groups.

import type { EvidenceProps } from './registry';

interface CampaignRow {
  name: string;
  assetGroups: string[];
}

interface StructureShape {
  totalCampaigns: number;
  totalAssetGroups: number;
  campaigns: CampaignRow[];
}

export const PmaxStructureEvidence = ({ evidence }: EvidenceProps) => {
  const e = evidence as unknown as StructureShape;

  return (
    <div className='evidence'>
      <section className='evidence__section'>
        <h4 className='evidence__section-title'>
          Structure Claude saw
          <span className='evidence__section-tag evidence__section-tag--context'>
            {e.totalCampaigns} campaigns · {e.totalAssetGroups} asset groups
          </span>
        </h4>
        <table className='evidence__table evidence__table--pmax-structure'>
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Asset groups</th>
            </tr>
          </thead>
          <tbody>
            {e.campaigns.map(c => (
              <tr key={c.name}>
                <td>{c.name}</td>
                <td>
                  <span className='evidence__modifier-list'>
                    {c.assetGroups.map((g, i) => (
                      <span key={`${g}-${i}`} className='evidence__audience-chip'>
                        {g}
                      </span>
                    ))}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <p className='evidence__footnote'>
        Tinuiti favors consolidated, tightly-themed structures: campaigns segmented by business
        objective (and asset groups sharing a goal/budget/targeting kept together), with asset
        groups themed by product category, margin, or audience so creative can be specific.
        Splitting by market or funnel stage is usually legitimate; arbitrarily fragmenting same-goal
        campaigns starves Smart Bidding of pooled conversion data.
      </p>
    </div>
  );
};
